import * as React from 'react'

function SvgEt(props) {
	return (
		<svg viewBox="0 0 720 360" width="1em" height="1em" {...props}>
			<path fill="#da121a" d="M0 0h720v360H0z" />
			<path fill="#fcdd09" d="M0 0h720v240H0z" />
			<path fill="#078930" d="M0 0h720v120H0z" />
			<g transform="translate(360 180)">
				<circle fill="#0f47af" r={120} />
				<g id="et_svg__a">
					<path
						fill="#fcdd09"
						d="M0-96l-4.206 12.944 17.348 53.39h-23.13l-2.599 8h74.163l11.011-8H21.553z"
					/>
					<path stroke="#fcdd09" strokeWidth={4} d="M25.863-35.597l30.564-42.069" />
				</g>
				<use xlinkHref="#et_svg__a" transform="rotate(72)" />
				<use xlinkHref="#et_svg__a" transform="rotate(144)" />
				<use xlinkHref="#et_svg__a" transform="rotate(216)" />
				<use xlinkHref="#et_svg__a" transform="rotate(288)" />
			</g>
		</svg>
	)
}

export default SvgEt
